/*eslint-disable */
export default function formMap(mapContainer) {
	const ADDRESS_INPUT = "adress";
	const POSTAL_INPUT = "postal";
	const CITY_INPUT = "city";
	const LNG_INPUT = "lng";
	const LAT_INPUT = "lat";
	const WKT_INPUT = "wkt";
	const MAP_IMAGE_INPUT = "image";
	const MAP_IMAGE_PREVIEW = "map-img-preview";
	const MAPCONTAINER_ID = mapContainer;

	// Add script to the page
	const script = document.createElement("script");
	script.src = "https://js.arcgis.com/4.24/";
	document.head.appendChild(script);

	script.onload = () => {
		initMap();
	};

	// Add stylesheet to the page
	const link = document.createElement("link");
	link.rel = "stylesheet";
	link.href = "https://js.arcgis.com/4.24/esri/themes/light/main.css";
	document.head.appendChild(link);

	function initMap() {
		let mapOptions = document.querySelector(`#${MAPCONTAINER_ID}`).dataset;

		window.require(
			[
				"esri/config",
				"esri/Map",
				"esri/views/MapView",
				"esri/Graphic",
				"esri/layers/GraphicsLayer",
				"esri/rest/locator",
				"esri/widgets/Sketch/SketchViewModel",
				"esri/widgets/Sketch",
				"esri/layers/WebTileLayer",
			],
			function (
				esriConfig,
				Map,
				MapView,
				Graphic,
				GraphicsLayer,
				locator,
				SketchViewModel,
				Sketch,
				WebTileLayer
			) {
				esriConfig.apiKey =
					"AAPK4dfd17c2ee34404dbf13cc158cf09cc0MYvfZAGO8Bmr1ZGyomht5Ih39mYyPQ7rGxm_Z9yRF992LFQbBikwqFCUFOZnxXj6";

				const osmLayer = new WebTileLayer({
					urlTemplate: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
					id: "osm",
					copyright:
						"Base map and data from <a class='external text' href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> and <a rel='nofollow' class='external text' href='https://www.osmfoundation.org'>OpenStreetMap Foundation</a>",
				});

				const map = new Map({
					basemap: "arcgis-navigation",
					layers: [osmLayer],
				});

				const view = new MapView({
					map: map,
					center: [mapOptions.centerLng, mapOptions.centerLat],
					zoom: mapOptions.zoom,
					container: MAPCONTAINER_ID,
				});

				const serviceUrl =
					"http://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer";
				const graphicsLayer = new GraphicsLayer();
				map.add(graphicsLayer);

				const sketch = new Sketch({
					layer: graphicsLayer,
					view: view,
					creationMode: "single",
					viewModel: new SketchViewModel({
						layer: graphicsLayer,
						view: view,
						pointSymbol: {
							type: "simple-marker",
							color: "#0061a1",
							size: 12,
							outline: {
								color: "#fff",
								width: 1,
							},
						},
					}),
				});

				sketch.visibleElements = {
					createTools: {
						circle: false,
						ellipse: false,
						rectangle: false,
						polyline: false,
						polygon: true,
						point: true,
					},
					selectionTools: {
						"lasso-selection": false,
						"rectangle-selection": false,
					},
					settingsMenu: false,
				};

				view.ui.add(sketch, "top-right");

				sketch.on("create", function (event) {
					if (event.state === "complete") {
						newGraphic(event.graphic);
					}
				});

				sketch.on("update", function (event) {
					if (event.state === "complete") {
						newGraphic(event.graphics[0]);
					}
				});

				sketch.on("delete", function () {
					graphicsLayer.graphics.removeAll();
					clearInputs();
					clearAddress();
				});

				function clearInputs() {
					document.querySelector(`[data-form-map="${WKT_INPUT}"]`).value = "";
					document.querySelector(`[data-form-map="${LNG_INPUT}"]`).value = "";
					document.querySelector(`[data-form-map="${LAT_INPUT}"]`).value = "";
					document.querySelector(`[data-form-map="${MAP_IMAGE_INPUT}"]`).value =
						"";
				}

				function clearAddress() {
					document.querySelector(`[data-form-map="${ADDRESS_INPUT}"]`).value =
						"";
					document.querySelector(`[data-form-map="${POSTAL_INPUT}"]`).value =
						"";
					document.querySelector(`[data-form-map="${CITY_INPUT}"]`).value = "";
				}

				function newGraphic(graphic) {
					graphicsLayer.graphics.removeAll();
					graphicsLayer.add(graphic);

					addGraphicToMap(graphic.geometry);

					setTimeout(() => {
						view.takeScreenshot().then(function (dataUrl) {
							addImageToForm(dataUrl.dataUrl);
							addPreviewImage(dataUrl.dataUrl);
						});
					}, 50);
				}

				function addGraphicToMap(geo) {
					const type = geo.type;

					if (type === "point") {
						getLocation(geo);
					}

					if (type === "polygon") {
						clearAddress();
						const wkt = convertToWKT(geo);
						setWkt(wkt);
					}
				}

				// Function that converts array to WKT format
				function convertToWKT(geo) {
					let arr = geo.rings[0];
					let wkt = geo.type.toUpperCase() + "((";
					arr.forEach((item) => {
						wkt += `${item[0]} ${item[1]},`;
					});
					wkt = wkt.slice(0, -1);
					wkt += "))";
					return wkt;
				}

				function setLatLng(lng, lat) {
					const mapContainer =
						document.getElementById(MAPCONTAINER_ID).parentNode;

					mapContainer.querySelector(`[data-form-map="${LNG_INPUT}"]`).value =
						lng;
					mapContainer.querySelector(`[data-form-map="${LAT_INPUT}"]`).value =
						lat;
				}

				function setWkt(wkt) {
					const mapContainer =
						document.getElementById(MAPCONTAINER_ID).parentNode;

					mapContainer.querySelector(`[data-form-map="${WKT_INPUT}"]`).value =
						wkt;
				}

				function setAddress(adress, postal, city) {
					document.querySelector(`[data-form-map="${ADDRESS_INPUT}"]`).value =
						adress;
					document.querySelector(`[data-form-map="${POSTAL_INPUT}"]`).value =
						postal;
					document.querySelector(`[data-form-map="${CITY_INPUT}"]`).value =
						city;
				}

				function getLocation(geo) {
					locator
						.locationToAddress(serviceUrl, {
							location: geo,
						})
						.then(
							function (response) {
								setAddress(
									response.attributes.Address,
									response.attributes.Postal,
									response.attributes.City
								);
								setLatLng(
									response.location.longitude,
									response.location.latitude
								);
							},
							function (err) {
								console.error(err);
							}
						);
				}

				function addImageToForm(base64) {
					const blob = base64ImageToBlob(base64);

					let today = new Date();
					today =
						today.getFullYear() +
						"-" +
						(today.getMonth() + 1) +
						"-" +
						today.getDate();

					const fileList = new DataTransfer();
					const file = new File([blob], `karta_${today}.png`, {
						type: "image/png",
					});
					fileList.items.add(file);

					const input = document.querySelector(
						`[data-form-map="${MAP_IMAGE_INPUT}"`
					);
					input.files = fileList.files;
				}

				function base64ImageToBlob(str) {
					const pos = str.indexOf(";base64,");
					const type = str.substring(5, pos);
					const b64 = str.substr(pos + 8);
					const imageContent = window.atob(b64);
					const buffer = new ArrayBuffer(imageContent.length);
					const view = new Uint8Array(buffer);

					for (let n = 0; n < imageContent.length; n++) {
						view[n] = imageContent.charCodeAt(n);
					}

					const blob = new Blob([buffer], { type: type });

					return blob;
				}

				function addPreviewImage(base64) {
					const img = document.querySelector(
						`[data-form-map="${MAP_IMAGE_PREVIEW}"]`
					);
					img.src = base64;
				}
			}
		);
	}
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./components/form-elements/form-map/c-form-map.js